import React from 'react'
import PropTypes from 'prop-types'

function SubmissionCategories({ buttons, activeCategory, onCategoryChange }) {
  return (
    <div>
      {buttons.map((button) => (
        <button
          key={button.slug}
          className={`btn btn-block ${activeCategory === button.slug ? 'btn-outline-primary' : 'btn-outline-default'}`}
          onClick={(e) => onCategoryChange(e, button.slug)}
        >{button.text}
        </button>
      ))}
    </div>
  )
}

SubmissionCategories.propTypes = {
  buttons: PropTypes.array.isRequired,
  onCategoryChange: PropTypes.func.isRequired,
  activeCategory: PropTypes.string,
}

SubmissionCategories.defaultPropTypes = {
  activeCategory: '',
}

export default SubmissionCategories
